import React from 'react';
const AppAddTxtView:React.FC = ()=>{
    return (
        <div>google.com, pub-7957814135972484, DIRECT, f08c47fec0942fa0</div>
    )
}

export default AppAddTxtView;